/* tslint:disable */
/* eslint-disable */
export enum WorkChatMemberRoleEnum {
  Owner = 'owner',
  Member = 'member'
}
